<template>
  <div>
    <v-flex class="pa-0 ma-0" sm12 xs12>
      <h3>Obrigado por sua compra</h3>
      <v-card>
        <v-img height="100px" src="/img/computer-and-coffe.jpg">
          <v-layout column fill-height>
            <v-card-title>
              <v-btn dark icon>
                <v-icon>shopping_basket</v-icon>
              </v-btn>
              <v-card-title class="white--text 5">
                <div class="display-1">Pedido #{{ order.id }}</div>
              </v-card-title>
            </v-card-title>
            <v-spacer></v-spacer>
          </v-layout>
        </v-img>

        <v-list two-line>
          <v-list-item v-if="order.items.data.length > 0">
            <v-list-item-icon>
              <v-icon>menu_book</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                order.items.data[0].saleable.course
              }}</v-list-item-title>
              <v-list-item-subtitle>Curso</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="order.items.data.length > 0">
            <v-list-item-icon>
              <v-icon>description</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="text-wrap">{{
                order.items.data[0].saleable.description
              }}</v-list-item-title>
              <v-list-item-subtitle>Descrição</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset></v-divider>

          <v-list-item v-if="order.gross_amount">
            <v-list-item-icon>
              <v-icon>attach_money</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ order.gross_amount }}</v-list-item-title>
              <v-list-item-subtitle>Valor total</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <div v-if="order.transactions && order.transactions.length > 0">
            <v-list-item>
              <v-list-item-icon>
                <v-img
                  v-if="order.transactions[0].payment_method_id === 2"
                  class="mt-3 mb-3 mr-4"
                  color="primary"
                  src="/img/checkout/barcode-product.svg"
                  width="16"
                >
                </v-img>
                <v-icon v-else>credit_card</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ paymentMethod }}
                </v-list-item-title>
                <v-list-item-subtitle>Forma de pagamento</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn
                  v-if="order.transactions[0].payment_method_id == 2"
                  :href="order.transactions[0].payment_link"
                  block
                  class="ma-2"
                  color="primary"
                  depressed
                  target="_blank"
                >
                  Visualizar Boleto&nbsp;&nbsp;
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>card_travel</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  order.transactions[0].gateway_identifier
                }}</v-list-item-title>
                <v-list-item-subtitle>identificador</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
            <div>
              <v-btn
                :to="{ name: 'courses' }"
                block
                class="ma-2"
                color="secondary"
              >
                Meus Cursos
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    paymentMethod: function () {
      // console.log(this.order.transactions)
      if (this.order.transactions.length > 1) return "Dois Cartões";
      switch (this.transaction[0].payment_method_id) {
        case 4:
          return "Cartão de Crédito";
        case 2:
          return "Boleto";
        default:
          return "Cartão";
      }
    },
  },
  mounted() {
    // console.log('Thanks ', this.$props.order)
  },
  methods: {},
};
</script>
